// eslint-disable-next-line max-len
// const Alarms = () => import(/* webpackChunkName: "mySigmaAlarms" */ '@/domain/components/generalPanel/mySigma/alarms/Alarms');
// const AlarmsIndex = () => import(/* webpackChunkName: "mySigmaAlarms" */ '../alarms');
// const Chart = () => import(/* webpackChunkName: "mySigmaChart" */ '../chart/Chart');
// eslint-disable-next-line max-len
// const ChartConfigurationIndex = () => import(/* webpackChunkName: "mySigmaChartConfiguration" */ '../chart/configuration');
// const ChartIndex = () => import(/* webpackChunkName: "mySigmaChart" */ '../chart');
// eslint-disable-next-line max-len
// const DigitalNetwork = () => import(/* webpackChunkName: "mySigmaDigitalNetwork" */ '../digitalNetwork/DigitalNetwork');
// eslint-disable-next-line max-len
// const DigitalNetworkConfigurationIndex = () => import(/* webpackChunkName: "mySigmaDigitalNetworkConfiguration" */ '../digitalNetwork/configuration');
// eslint-disable-next-line max-len
// const DigitalNetworkIndex = () => import(/* webpackChunkName: "mySigmaDigitalNetwork" */ '../digitalNetwork');
const GeneralPanel = () => import(/* webpackChunkName: "mySigmaGeneralPanel" */ '../../GeneralPanel');
// const MySigma = () => import(/* webpackChunkName: "mySigma" */ '../index');
// eslint-disable-next-line max-len
// const SetupInstallations = () => import(/* webpackChunkName: "mySigmaSetupInstallations" */ '../alarms/setupInstallations');
// eslint-disable-next-line max-len
// const Supervision = () => import(/* webpackChunkName: "mySigmaSupervision" */ '../supervision/Supervision');
// eslint-disable-next-line max-len
// const SupervisionConfigurationIndex = () => import(/* webpackChunkName: "mySigmaSupervisionConfiguration" */ '../supervision/configuration');
// eslint-disable-next-line max-len
// const SupervisionIndex = () => import(/* webpackChunkName: "mySigmaSupervision" */ '../supervision');
//
// const DEFAULT_ROUTE = {
//   name: 'my-sigma.alarms',
// };

export default {
  path: '',
  props: true,
  component: GeneralPanel,
  // children: [
  //   {
  //     path: 'meu-sigma',
  //     name: 'my-sigma',
  //     component: MySigma,
  //     meta: {
  //       breadcrumb: {
  //         name: 'page-name.my-sigma',
  //         noNavigation: true,
  //       },
  //     },
  //     redirect: DEFAULT_ROUTE,
  //     children: [
  //       {
  //         path: 'alarmes',
  //         component: Alarms,
  //         noNavigation: true,
  //         meta: {
  //           breadcrumb: {
  //             routeName: 'my-sigma.alarms',
  //             name: 'page-name.my-sigma-alarms',
  //           },
  //         },
  //         children: [
  //           {
  //             path: '',
  //             name: 'my-sigma.alarms',
  //             component: AlarmsIndex,
  //             meta: {
  //               breadcrumb: {
  //                 name: 'page-name.my-sigma',
  //                 noNavigation: true,
  //                 icon: 'fas fa-tachometer-alt',
  //               },
  //             },
  //           },
  //           {
  //             path: 'configuracao',
  //             name: 'my-sigma.alarms.configuration',
  //             component: SetupInstallations,
  //             meta: {
  //               showAutoRefresh: false,
  //               breadcrumb: {
  //                 name: 'page-name.my-sigma-alarms-configuration',
  //               },
  //             },
  //           },
  //         ],
  //       },
  //       {
  //         path: 'rede-digital',
  //         component: DigitalNetworkIndex,
  //         noNavigation: true,
  //         meta: {
  //           breadcrumb: {
  //             routeName: 'my-sigma.digital-network',
  //             name: 'page-name.my-sigma-digital-network',
  //           },
  //         },
  //         children: [
  //           {
  //             path: '',
  //             name: 'my-sigma.digital-network',
  //             component: DigitalNetwork,
  //             meta: {
  //               breadcrumb: {
  //                 name: 'page-name.my-sigma',
  //                 icon: 'fas fa-tachometer-alt',
  //                 noNavigation: true,
  //               },
  //             },
  //           },
  //           {
  //             path: 'configuracao',
  //             name: 'my-sigma.digital-network.configuration',
  //             component: DigitalNetworkConfigurationIndex,
  //             meta: {
  //               showAutoRefresh: false,
  //               breadcrumb: {
  //                 name: 'page-name.my-sigma-digital-network-configuration',
  //               },
  //             },
  //           },
  //         ],
  //       },
  //       {
  //         path: 'supervisao',
  //         component: SupervisionIndex,
  //         noNavigation: true,
  //         meta: {
  //           breadcrumb: {
  //             routeName: 'my-sigma.supervision',
  //             name: 'page-name.my-sigma-supervision',
  //           },
  //         },
  //         children: [
  //           {
  //             path: '',
  //             name: 'my-sigma.supervision',
  //             component: Supervision,
  //             meta: {
  //               breadcrumb: {
  //                 name: 'page-name.my-sigma',
  //                 noNavigation: true,
  //                 icon: 'fas fa-tachometer-alt',
  //               },
  //             },
  //           },
  //           {
  //             path: 'configuracao',
  //             name: 'my-sigma.supervision.configuration',
  //             component: SupervisionConfigurationIndex,
  //             meta: {
  //               showAutoRefresh: false,
  //               breadcrumb: {
  //                 name: 'page-name.my-sigma-supervision-configuration',
  //               },
  //             },
  //           },
  //           {
  //             path: 'editar/:groupId',
  //             name: 'my-sigma.supervision.edit-group',
  //             component: SupervisionConfigurationIndex,
  //             props: { default: true, sidebar: 'false' },
  //             meta: {
  //               showAutoRefresh: false,
  //               breadcrumb: {
  //                 name: 'page-name.my-sigma-supervision-edit',
  //               },
  //             },
  //           },
  //         ],
  //       },
  //       {
  //         path: 'grafico',
  //         component: ChartIndex,
  //         noNavigation: true,
  //         meta: {
  //           breadcrumb: {
  //             routeName: 'my-sigma.chart',
  //             name: 'page-name.my-sigma-chart',
  //           },
  //         },
  //         children: [
  //           {
  //             path: '',
  //             name: 'my-sigma.chart',
  //             component: Chart,
  //             meta: {
  //               breadcrumb: {
  //                 name: 'page-name.my-sigma',
  //                 icon: 'fas fa-tachometer-alt',
  //                 noNavigation: true,
  //               },
  //             },
  //           },
  //           {
  //             path: 'novo',
  //             name: 'my-sigma.chart.new-chart',
  //             component: ChartConfigurationIndex,
  //             meta: {
  //               showAutoRefresh: false,
  //               breadcrumb: {
  //                 name: 'page-name.my-sigma-chart-configuration',
  //               },
  //             },
  //           },
  //           {
  //             path: 'editar/:chartId',
  //             name: 'my-sigma.chart.edit-chart',
  //             component: ChartConfigurationIndex,
  //             meta: {
  //               showAutoRefresh: false,
  //               breadcrumb: {
  //                 name: 'page-name.my-sigma-chart-configuration',
  //               },
  //             },
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // ],
};
